'use strict';

module.exports = require('./lib/React');



/*****************
 ** WEBPACK FOOTER
 ** ./~/react/react.js
 ** module id = ./node_modules/react/react.js
 ** module chunks = 1
 **/